// extracted by mini-css-extract-plugin
module.exports = {"ganttVerticalContainer":"gantt_ganttVerticalContainer__28X8j","horizontalContainer":"gantt_horizontalContainer__2Kliq","wrapper":"gantt_wrapper__3ke-T"};